import "../../scss/DetailView.scss";
import "../../scss/Common.scss";
import "../../scss/Swiper.scss";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function ContentView({ content }: { content: string }) {
  return (
    <div>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          img: ({ node, ...props }) => (
            <img
              style={{
                display: "block",
                margin: "0 auto",
                maxWidth: "80%",
                height: "auto",
                borderRadius: "8px",
              }}
              {...props}
            />
          ),
          a: ({ href, children }) => {
            const match = href?.match(
              /^https?:\/\/(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?([^&]+)/
            );
            if (match) {
              const videoId = match[1];
              return (
                <div style={{ margin: "20px 0" }}>
                  <iframe
                    width="560"
                    height="315"
                    src={`https://www.youtube.com/embed/${videoId}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded YouTube Video"
                  />
                </div>
              );
            }
            return <a href={href}>{children}</a>;
          },
        }}
        className="prose max-w-none"
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
